import React from 'react';

const EmailIntroduction = () => {
  return (
    <div className="mt-5 govuk-bp:mt-10">
      <h1 className="govuk-heading-l">Your email address</h1>
      <p className="govuk-body">
        It is important that your email address is up to date.
      </p>
      <h3 className="govuk-heading-s">
        When your MyWishes Care Account is linked to more than one organisation
      </h3>
      <p className="govuk-body">
        MyWishes Care allows those providing care in different locations and for
        different organisations to access patient case loads from one user
        account. This means that our users do not need to login and out with
        different credentials for each organisation that they work for.
      </p>
      <p className="govuk-body">
        Each organisation grants access to those using MyWishes Care
        individually. They are responsible for adding and removing those who
        work for them and the level of access each person has.
      </p>

      <div className="govuk-warning-text">
        <span className="govuk-warning-text__icon" aria-hidden="true">
          !
        </span>
        <strong className="govuk-warning-text__text">
          <span className="govuk-visually-hidden">Warning</span>
          If your account is linked to more than one organisation and the email
          used in MyWishes Care is owned by an organisation that you work for,
          please change it before leaving them.
        </strong>
      </div>

      <h3 className="govuk-heading-s">If you do not change your email and:</h3>
      <ul className="govuk-list govuk-list--bullet">
        <li>
          You are removed from the the organisation&apos;s MyWishes Care
          environment
        </li>
        <li>
          The email account provided to you with is deleted by the organisation
        </li>
      </ul>
      <p className="govuk-body">
        You will no longer have access to any of the other organisations case
        loads that you had previously been granted access to.
      </p>
      <p className="govuk-body">
        If you update your email address within MyWishes Care ahead of time and
        you are then removed by the organisation, your account will remain
        active and you will be able to continue to support patients for any
        other organisations that you still work for.
      </p>
      <p className="govuk-body">
        If your MyWishes Care account is only linked to one organisation, you do
        not need to take any action when leaving the organisation.
      </p>
    </div>
  );
};

export default EmailIntroduction;
